import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

/**
 * A component for separating content on a page
 */
function Divider({ weight }) {
  return <hr className={classNames({ thick: weight === 'thick', thin: weight === 'thin' })} />;
}

Divider.propTypes = {
  /**
   * The thickness of the divider
   */
  weight: PropTypes.oneOf(['thick', 'thin'])
};

export default Divider;
